import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth';

export function useDocumentTitle(): void {
  const user = useAuthStore((s) => s.user);
  useEffect(() => {
    document.title = user?.ig_username
      ? `The 3333 Games | @${user.ig_username}`
      : 'The 3333 Games';
  }, [user?.ig_username]);
}
